/**
 * Artemis Application Server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * API Version: 10.6
 * Contact: krusche@tum.de
 *
 * NOTE: This file is auto-generated. Do not edit manually.
 */

/**
 * HyperionProgrammingVariantApi - API service
 * @generated from OpenAPI specification
 */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExerciseGenerationJobStart } from '../model/exercise-generation-job-start';
import { VariantGenerationRequest } from '../model/variant-generation-request';

@Injectable({ providedIn: 'root' })
export class HyperionProgrammingVariantApi {
    private readonly http = inject(HttpClient);
    private readonly basePath = '';

    /**
     *
     *
     * @param exerciseId
     * @param variantGenerationRequest
     */
    generateProgrammingVariant(exerciseId: number, variantGenerationRequest: VariantGenerationRequest): Observable<ExerciseGenerationJobStart> {
        const url = `${this.basePath}/api/hyperion/programming-exercises/${exerciseId}/generation/variants`;
        return this.http.post<ExerciseGenerationJobStart>(url, variantGenerationRequest);
    }

}
